import { render, staticRenderFns } from "./LessonEdit.vue?vue&type=template&id=64883295&scoped=true&"
import script from "./LessonEdit.vue?vue&type=script&lang=js&"
export * from "./LessonEdit.vue?vue&type=script&lang=js&"
import style0 from "./LessonEdit.vue?vue&type=style&index=0&id=64883295&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64883295",
  null
  
)

export default component.exports